{
  "eventDetails": "Detalles del evento",
  "helpContentBodyText": "Muestra los 10 eventos más recientes informados por este dispositivo.\n\nVisualiza informes de diferentes sensores al tocarlos o hacer clic en ellos en Sensores de informes.\n\nVisualiza eventos más antiguos y más recientes al tocar o hacer clic en \"más antiguo\" y \"más nuevo\".",
  "linkTo": "Eventos",
  "noDataForSensorWithSensorName": "No hay datos para el sensor {{sensorName}}",
  "noOlderEventsFoundForThisDevice": "No se encontraron eventos anteriores para este dispositivo.",
  "reportingSensors": "Sensores de informes",
  "sensorReport": "Informe del sensor {{sensorName}}",
  "subheader": "Haga clic o toque para inspeccionar",
  "title": "Historial de eventos"
}
